var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPremantDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 39,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Premant-Delete_svg__a)",
  d: "M32.197 4.713 26.245 2.92a21.653 21.653 0 0 0-12.49 0L7.802 4.713c-.897.27-1.618.94-1.953 1.816L3 13.963A13.358 13.358 0 0 0 7.31 29.311l7.783 6.014a8.026 8.026 0 0 0 9.815 0l7.784-6.014a13.358 13.358 0 0 0 4.307-15.348L34.15 6.53a3.028 3.028 0 0 0-1.954-1.816Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M2.068 13.606 4.915 6.17a4.027 4.027 0 0 1 2.599-2.416l-5.446 9.85Zm0 0a14.358 14.358 0 0 0 4.63 16.496l7.783 6.014M2.068 13.606l12.413 22.51m0 0a9.026 9.026 0 0 0 11.037 0l7.784-6.014a14.358 14.358 0 0 0 4.63-16.496L35.085 6.17a4.028 4.028 0 0 0-2.6-2.416l-5.952-1.792-12.052 34.153ZM13.467 1.963 7.513 3.755l19.02-1.792a22.653 22.653 0 0 0-13.067 0Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Premant-Delete_svg__b)",
  d: "M29.318 10.328A12.906 12.906 0 0 0 20 6.368c-7.15 0-12.945 5.796-12.945 12.946 0 3.66 1.518 6.963 3.959 9.318l8.342 8.342a8.018 8.018 0 0 0 5.551-1.65l7.784-6.013a13.357 13.357 0 0 0 5.19-10.42l-8.563-8.563Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Premant-Delete_svg__c)",
  d: "M6.604 28.725c.227.202.462.398.705.586l7.784 6.014a8.025 8.025 0 0 0 9.814 0l7.784-6.014c.244-.188.478-.384.706-.586H6.604Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Premant-Delete_svg__d)",
  d: "M32.946 19.314c0 7.15-5.796 12.946-12.946 12.946-7.15 0-12.945-5.796-12.945-12.946 0-7.15 5.796-12.946 12.945-12.946 7.15 0 12.946 5.796 12.946 12.946Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Premant-Delete_svg__e)",
  d: "m32.943 19.537-7.218-7.217a1.352 1.352 0 0 0-1.913 0l-2.856 2.856a1.353 1.353 0 0 1-1.912 0l-2.857-2.856a1.352 1.352 0 0 0-1.913 0l-1.268 1.269a1.353 1.353 0 0 0 0 1.912l2.856 2.857a1.353 1.353 0 0 1 0 1.912l-2.857 2.857a1.353 1.353 0 0 0 0 1.912l7.218 7.218c6.972-.118 12.602-5.748 12.72-12.72Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m26.994 23.127-2.857-2.857a1.353 1.353 0 0 1 0-1.912l2.857-2.857a1.353 1.353 0 0 0 0-1.912l-1.269-1.27a1.352 1.352 0 0 0-1.913 0l-2.856 2.857a1.353 1.353 0 0 1-1.913 0l-2.856-2.856a1.352 1.352 0 0 0-1.913 0l-1.269 1.269a1.353 1.353 0 0 0 0 1.912l2.857 2.857a1.353 1.353 0 0 1 0 1.912l-2.857 2.857a1.353 1.353 0 0 0 0 1.912l1.27 1.27a1.353 1.353 0 0 0 1.912 0l2.856-2.857a1.353 1.353 0 0 1 1.913 0l2.857 2.856a1.353 1.353 0 0 0 1.912 0l1.27-1.269a1.353 1.353 0 0 0 0-1.912Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Premant-Delete_svg__a",
  x1: 12.352,
  x2: 26.909,
  y1: 9.433,
  y2: 23.99,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B65CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6B01C2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Premant-Delete_svg__b",
  x1: 35.725,
  x2: 25.015,
  y1: 35.038,
  y2: 24.328,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.003,
  stopColor: "#5E13D9",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.076,
  stopColor: "#5E13D9",
  stopOpacity: 0.075
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5E13D9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Premant-Delete_svg__c",
  x1: 20,
  x2: 20,
  y1: 30.019,
  y2: 36.436,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.003,
  stopColor: "#7326F1",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.076,
  stopColor: "#7326F1",
  stopOpacity: 0.075
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7326F1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Premant-Delete_svg__e",
  x1: 28.549,
  x2: 19.549,
  y1: 27.864,
  y2: 18.864,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6E24E8",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.074,
  stopColor: "#6E24E8",
  stopOpacity: 0.075
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.335,
  stopColor: "#6E24E8",
  stopOpacity: 0.229
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.583,
  stopColor: "#6E24E8",
  stopOpacity: 0.584
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.811,
  stopColor: "#6E24E8",
  stopOpacity: 0.812
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6E24E8"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Premant-Delete_svg__d",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(15.808 14.704) scale(20.2979)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E6D3FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.208,
  stopColor: "#CFAFFA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.396,
  stopColor: "#B995E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.576,
  stopColor: "#BD8AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#A864FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.901,
  stopColor: "#9B4DFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9340FD"
})))));
export { SvgPremantDelete as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZWNiOTJhNjk4ZDMxZTI5NDg5ZGQyMWQ5ZjI2YTczMjcuc3ZnIjs=";